//
//
//
//
//
//
//
//
//
//
//
//

  import Vue from 'vue'
  //轮播插件
  import VueAwesomeSwiper from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  Vue.use(VueAwesomeSwiper)

  export default {
    name: 'carrousel',
    props:['imgArrB','imgIndex'],
    data() {
      return {
        swiperOption: {
          // spaceBetween: 30,
          loop: true,
          init:true,
//          initialSlide:this.imgIndex,
          pagination: {
            el: '.swiper-pagination',
            type: "bullets"
          }
        }
      }
    },
    methods:{
      changeBigTar(){
          this.$parent.closeBig();
      }
    },
    computed: {
      swiper(){
        return this.$refs.myswiperB.swiper;
      }
    },
    updated() {
        console.log(this.imgIndex)
      if (this.imgArrB.length>1) {
        this.swiper.init();
        this.swiper.slideTo(this.imgIndex)
      }
    }
  }



// WEBPACK FOOTER //
// ./src/components/swiper/carouselBig.vue